// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "connect/styles/wp-" + "7afce05143cc89480a99" + ".css";
};